import EzController from 'controllers/ez-base-controller';
import { sendTrackingEvent, trackCompleteEvent, findCategoryByElement } from 'components/analytics/conversions/tracking';
import { isEnvironment } from 'lib/helpers';

/* This controller is now deprecated. Please use TrackEventController or TrackCompleteEventController */
export default class EventTrackerController extends EzController {
  static values = {
    trackAction: String,
    completeAction: String,
    trackLabel: String,
    trackValue: String,
    includeData: String,
    sendFromElement: { type: Boolean, default: true },
  }

  track(event) {
    const payload = {
      action: this.trackActionValue,
    };

    if (this.hasTrackLabelValue) payload.label = this.trackLabelValue;
    if (this.hasTrackValueValue) payload.value = this.trackValueValue;

    Object.assign(payload, this.processIncludedData());

    /*
     * setting sendFromElement to false will force the event to
     * send from the body tag instead of the element.
     * This is good for things like modals that disappear
     * after events like ajax:success
    */
    const trackedEvent = { data: payload };
    if (this.sendFromElementValue) {
      trackedEvent.element = event.target;
    }

    sendTrackingEvent(trackedEvent);

    if (isEnvironment('dev')) {
      this.deprecationWarning(this.trackActionValue, this.element);
    }
  }

  trackComplete(event) {
    trackCompleteEvent({
      action: this.completeActionValue,
      category: findCategoryByElement(event.target),
    });

    if (isEnvironment('dev')) {
      this.deprecationWarning(this.completeActionValue, this.element);
    }
  }

  deprecationWarning(action, target) {
    /* eslint-disable-next-line no-console */
    console.warn(`This tracker is deprecated. Please upgrade ${action} to use Track Event Controller or Track Complete Event Controller. Target:`, target);
  }

  processIncludedData() {
    if (!this.hasIncludeDataValue) return {};

    const data = {};
    const values = this.includeDataValue.split(',').map((i) => i.trim());
    values.forEach((value) => {
      data[value] = this.element.dataset[value];
    });

    return data;
  }
}
